import React, { FC } from "react";

import { Text, Tooltip } from "@costar-ui/components";

import { HelpTooltipProps } from "./types";

import { MainProductIds } from "$common/nav-config";

const HelpTooltip: FC<HelpTooltipProps> = props => {
    const { resources, tooltipOpen, productMode, buttonRef } = props;
    const isStr = productMode === MainProductIds.STR;
    return (
        <Tooltip isOpen={tooltipOpen} triggerRef={buttonRef} color="primary-contrast" className="border-0">
            <Text>
                {isStr
                    ? resources.search.common.share.shareFeedback()
                    : resources.search.common.share.helpAndFeedback()}
            </Text>
        </Tooltip>
    );
};

export default HelpTooltip;
